import { useCallback, useEffect, useState } from 'react';

export function useApiList(apiFn, deps = []) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const refetch = useCallback(() => setReloadKey((key) => key + 1), []);

  useEffect(() => {
    let cancelled = false;
    Promise.resolve()
      .then(() => {
        if (cancelled) return null;
        setLoading(true);
        setError(null);
        return apiFn();
      })
      .then((result) => {
        if (cancelled || !result) return;
        const { data: responseData, error: responseError } = result;
        if (responseError) {
          setError(responseError);
          return;
        }
        setData(Array.isArray(responseData) ? responseData : (responseData?.items ?? []));
      })
      .catch((err) => {
        if (!cancelled) setError(err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, reloadKey]);

  return { data, loading, error, refetch };
}